import { toggleScriptByConsent, isScriptLoaded, removeScriptById } from 'optimized-react-component-library-xyz123'

export const SITE_IMPROVE_SCRIPT_URL = 'https://siteimproveanalytics.com/js/siteanalyze_545452.js'
const SITE_IMPROVE_SCRIPT_ID = 'siteimprove-analytics'

export const toggleSiteImproveScript = (consent: boolean): void => {
    toggleScriptByConsent(consent, {
        id: SITE_IMPROVE_SCRIPT_ID,
        src: SITE_IMPROVE_SCRIPT_URL,
        attributes: { 'data-cookieconsent': 'statistics' },
    })
}

export const isSiteImproveLoaded = (): boolean => {
    return isScriptLoaded(SITE_IMPROVE_SCRIPT_ID)
}

export const removeAllAnalyticsScripts = (): void => {
    removeScriptById(SITE_IMPROVE_SCRIPT_ID)
}
